import "core-js/modules/es.object.to-string";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serverList, serverUpdateLog } from "@/api/gmToolNew/gmToolNew";
import { usersListAlls } from "@/api/user";
import { gmToolNew, gmToolNewPage } from "@/mixins/index";
export default {
  name: "serverLisyRecordsz",
  mixins: [gmToolNew, gmToolNewPage],
  data: function data() {
    return {
      reqLoading: false,
      severlists: [],
      total: 0,
      paramsData: {
        serverID: ''
      },
      list: [],
      value2: [],
      usersList: []
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getusersListAlls();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getList: function getList() {
      var _this2 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.paramsData.starttime = this.value2 ? this.value2[0] : '';
      this.paramsData.endtime = this.value2 ? this.value2[1] : '';
      this.reqLoading = true;
      this.paramsData.page = page;
      serverUpdateLog(_objectSpread(_objectSpread({}, this.paramsData), {}, {
        time: 1
      })).then(function (res) {
        if (res.status == 200) {
          _this2.list = res.data.data;
          _this2.total = res.data.total;
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },
    getusersListAlls: function getusersListAlls() {
      var _this3 = this;

      usersListAlls().then(function (res) {
        if (res.status == 200) {
          _this3.usersList = res.data;
        }
      });
    },
    getServer: function getServer() {
      var _this4 = this;

      this.paramsData.serverID = '';
      serverList(_objectSpread(_objectSpread({}, this.paramsData), {}, {
        page_size: ''
      })).then(function (res) {
        if (res.code == 200) {
          _this4.severlists = res.data;
        }
      });
    }
  }
};